module.exports = fox._r("images/slides/urban/slide_2_1.jpg", __webpack_public_path__ + "images/slides/urban/slide_2_1.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/urban/slide_2_1.jpg
// module id = 54
// module chunks = 2